import type { Command } from 'commander';
import { Logger } from '@gitlab-org/logging';
import { MarketplaceRegistry } from '@gitlab-org/duo-plugin-marketplace/node';
import type { DuoCommand } from '../../duo_command';
import { ExitHandler } from '../../../utils/exit';
import type { PluginContainerProvider } from '../plugin_services';

export class MarketplaceUpdateCommand implements DuoCommand {
  readonly name = 'update <name>';

  readonly description = "Refresh a registered marketplace's catalog from its source.";

  readonly #containerProvider: PluginContainerProvider;

  constructor(containerProvider: PluginContainerProvider) {
    this.#containerProvider = containerProvider;
  }

  register(node: Command): void {
    node.action(async (name: string) => {
      const registry = this.#containerProvider.getRequiredService(MarketplaceRegistry, node);

      try {
        const result = await registry.refresh(name);
        const revisionChange =
          result.marketplace.installedRevision &&
          result.marketplace.installedRevision !== result.previousRevision
            ? ` (${(result.previousRevision ?? 'none').slice(0, 7)} -> ${result.marketplace.installedRevision.slice(0, 7)})`
            : '';
        // eslint-disable-next-line no-console
        console.log(`Refreshed marketplace ${name}${revisionChange}`);
      } catch (e) {
        const logger = this.#containerProvider.getRequiredService(Logger, node);
        logger.error('Failed to update marketplace', e instanceof Error ? e : new Error(String(e)));
        const message = e instanceof Error ? e.message : String(e);
        // eslint-disable-next-line no-console
        console.error(`Failed to update marketplace: ${message}`);
        await this.#containerProvider.getRequiredService(ExitHandler, node).exit(1);
      }
    });
  }
}
